import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import AimPortal from './aim/AimPortal'
import Dynamics from './dynamics/Dynamics'
import RoundControl from './control/RoundControl'
import Participate from './participate/Participate'
import ErrorBoundary from './aim/ErrorBoundary'
import './base.css'
import './aim/aim.css'

function Route() {
  const path = location.pathname
  if (path.startsWith('/dinamicas') || path.startsWith('/reto-robo')) return <Dynamics />
  if (path.startsWith('/control')) return <RoundControl />
  if (path.startsWith('/participa')) return <Participate />
  return <AimPortal />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Route />
    </ErrorBoundary>
  </StrictMode>
)